import { map, tap } from 'rxjs/operators';
import APIv4GetProductsByFiltersResponseAdapter from './Adapters/APIv4GetProductsByFiltersResponseAdapter';
class StoreSearchRepository {
  // TODO: ProductCollectionDependency https://setnext.scalefast.ninja/scalefast/frontend/pandora/-/issues/570
  constructor(context, samHttpClient, meCachisDependencyService) {
    this.context = context;
    this.samHttpClient = samHttpClient;
    this.meCachisDependencyService = meCachisDependencyService;
  }
  findByFeed(params, metaproductColors) {
    const url = this.context.storeSearchBaseUrl;
    return this.samHttpClient.get(url, {
      params
    }).pipe(map(response => APIv4GetProductsByFiltersResponseAdapter.toProductByFilters(response, metaproductColors)));
  }
  findByFilters(params, metaproductColors) {
    const url = this.context.storeSearchBaseUrl;
    return this.samHttpClient.get(url, {
      params
    }).pipe(map(response => APIv4GetProductsByFiltersResponseAdapter.toProductByFilters(response, metaproductColors)), tap(response => this.meCachisDependencyService.addProducts(response.products)));
  }
  /**
   * This method is duplicated in storesearch config, but probably only SAM repository should have it moving forward
   */
  getStoreSearchEnv(samV4Context) {
    let env;
    if (samV4Context.environment === 'production') {
      env = 'prod';
    } else if (samV4Context.environment === 'development') {
      env = 'dev';
    } else {
      env = `${samV4Context.machineName}-local`;
    }
    return env;
  }
  criteriaToStoreSearchCrit(criteria) {
    const critArray = Object.entries(criteria.fields).map(([criterion, value]) => {
      return `${criterion}:${value}`;
    });
    if (!critArray.length) {
      throw new Error('No valid criteria found criteria');
    }
    return critArray.join('/');
  }
  getStoreSearchParams(criteria) {
    return {
      crit: this.criteriaToStoreSearchCrit(criteria),
      locale: this.context.locale,
      userID: this.context.userID,
      currency: criteria.currency,
      env: this.getStoreSearchEnv(this.context)
    };
  }
  /**
   * Generic search by criteria in StoreSearch method.
   * TODO: Criteria should implement most of https://setnext.scalefast.ninja/scalefast/v4/lambda/storesearch interface
   * TODO: Specific adapters and StoreSearchProduct interfaces need to be built
   */
  findByCriteria(criteria) {
    const params = this.getStoreSearchParams(criteria);
    return this.samHttpClient.get(this.context.storeSearchBaseUrl, {
      params
    }).pipe(map(response => APIv4GetProductsByFiltersResponseAdapter.toProductByFilters(response).products),
    //FIXME use a specific new adapter
    tap(response => this.meCachisDependencyService.addProducts(response.products)));
  }
}

export { StoreSearchRepository as default };